import axios from 'axios';
import { useAuthStore } from '@/store/useAuthStore';

const HTTP_HEADERS_AUTHORIZATION = 'Authorization';
const HTTP_HEADERS_X_ACCESS_TOKEN = 'X-Access-Token';
const HTTP_HEADERS_X_REFRESH_TOKEN = 'X-Refresh-Token';

// API 기본 URL 설정 - 로컬 개발 환경에서만 프록시 사용
const isLocalDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const API_BASE_URL = isLocalDev
    ? '/api/v1'  // 로컬: 프록시 경로 사용 (같은 오리진으로 처리)
    : (import.meta.env.VITE_ADMIN_BACKEND_API_URL || 'http://localhost:8080/api/v1');  // 개발/운영: 실제 API URL

// axios 인스턴스 생성 및 설정
const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        // API 요청임을 나타내는 커스텀 헤더 추가
        'X-API-Request': 'true'
    },
    timeout: 30000, // 30초로 타임아웃 연장
});

// 요청 인터셉터 설정 - HttpOnly 쿠키 전용 (보안 강화)
apiClient.interceptors.request.use(
    (config) => {
        // HttpOnly 쿠키를 포함하여 요청 (브라우저가 자동으로 전송)
        config.withCredentials = true;

        // 쿠키는 브라우저가 자동으로 전송

        return config;
    },
    (error) => {
        // 요청 에러
        return Promise.reject(error);
    }
);

// 응답 인터셉터 추가 - 401 에러 시 로그인 페이지로 이동
apiClient.interceptors.response.use(
    (response) => {
        // 백엔드에서 토큰 갱신이 자동으로 처리되어 쿠키가 업데이트됨

        return response;
    },
    async (error) => {
        // 에러 처리

        // 401 에러: 모든 토큰이 만료된 경우 (리프레시 토큰도 만료)
        // 백엔드에서 액세스 토큰 자동 갱신을 시도했지만 실패한 경우 401 반환
        if (error.response?.status === 401) {
            // 401 에러: 모든 토큰이 만료된 경우

            // 로그아웃 처리
            const { logout } = useAuthStore.getState();
            logout();

            // 로그인 페이지로 이동하면서 현재 경로 저장
            const currentPath = window.location.pathname;
            window.location.href = `/login?redirect=${encodeURIComponent(currentPath)}`;
        }

        return Promise.reject(error);
    }
);

export default apiClient;
export { API_BASE_URL };
export { HTTP_HEADERS_AUTHORIZATION };
export { HTTP_HEADERS_X_ACCESS_TOKEN };
export { HTTP_HEADERS_X_REFRESH_TOKEN };